import { GraduationCap } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { tutorialWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  tutorialWeb,
  {
    TutorialLauncher: () => import('./TutorialLauncher'),
    TutorialOverlay: () => import('./TutorialOverlay'),
    TutorialCompletionTracker: () => import('./TutorialCompletionTracker'),
    TutorialFirstVisitPrompt: () => import('./TutorialFirstVisitPrompt'),
    TutorialStartConfirm: () => import('./TutorialStartConfirm'),
    TutorialPageBanner: () => import('./TutorialPageBanner'),
    TutorialE2EBridge: () => import('./TutorialE2EBridge'),
    TutorialsPage: () => import('./TutorialsPage'),
  },
  {
    icons: { GraduationCap },
  },
);
